import { PageTitle } from "@/components/page-title";
import { TableCellLink } from "@/components/table-cell-link";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { DraftInvoice, PropsWithUser } from "@/types";
import { CircleCheckIcon, CircleDashedIcon, CircleXIcon } from "lucide-react";

type Props = PropsWithUser & {
  draft_invoices: DraftInvoice[];
};

export default function DraftInvoiceIndex({ draft_invoices }: Props) {
  return (
    <>
      <PageTitle>Draft invoices</PageTitle>
      <div className="mt-4 overflow-hidden rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>File</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {draft_invoices.map((draftInvoice) => {
              const href = `/draft_invoices/${draftInvoice.id}`;

              return (
                <TableRow key={draftInvoice.id}>
                  <TableCell className="font-medium">
                    <TableCellLink href={href} />
                    {draftInvoice.filename}
                  </TableCell>
                  <TableCell>
                    <TableCellLink href={href} tabIndex={-1} />
                    {DraftInvoiceStatus(draftInvoice.status)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </>
  );
}

function DraftInvoiceStatus(status: DraftInvoice["status"]) {
  if (status === "processing") {
    return (
      <Badge variant="secondary">
        <CircleDashedIcon />
        Processing
      </Badge>
    );
  } else if (status === "succeeded") {
    return (
      <Badge
        variant="secondary"
        className="bg-green-500/15 text-green-700 dark:bg-green-500/10 dark:text-green-400"
      >
        <CircleCheckIcon />
        Succeeded
      </Badge>
    );
  } else if (status === "failed") {
    return (
      <Badge
        variant="secondary"
        className="bg-red-500/15 text-red-700 dark:bg-red-500/10 dark:text-red-400"
      >
        <CircleXIcon />
        Failed
      </Badge>
    );
  }
}
